// extracted by mini-css-extract-plugin
module.exports = {"footer":"bk_fq","footerDark":"bk_gQ"};